module.exports = __webpack_public_path__ + "static/ocean-signature.5a7c079e.jpg";